<template>
  <div>
    <table
      id="coldChainDirection"
      class="uk-table"
    >
      <thead>
        <tr>
          <th>Proceso</th>
          <th>Producto</th>
          <th>Temperatura</th>
        </tr>
      </thead>
      <tbody
        v-for="prod in groupProductByProcess"
        :key="prod.product"
      >
        <tr
          v-for="proc in prod.processes"
          :key="proc.processId"
        >
          <th>{{ proc.process }}</th>
          <th>{{ proc.product }}</th>
          <th>{{ proc.temperature }}</th>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import groupProductByProcessMixins from '../../mixins/groupProductByProcessMixins'

export default {
  mixins: [groupProductByProcessMixins],
  computed: {
  }
}
</script>

<style scoped>

thead, tbody{
  display: table-header-group;

}
.uk-table{
  border: 1px solid #000;
}
thead th{
    background: #014968;
    color: #fff;
    padding: 10px;
    text-align: center;
}
tbody th{
    border-top: 1px solid #000;
    text-align: center;
}
@media screen and (max-width: 940px) {
  *{
    font-size: 10px !important;
  }
  thead th{
    background: #014968;
    color: #fff;
    padding: 5px;
    text-align: center;
}
tbody th{
    border-top: 1px solid #000;
    text-align: center;
    padding: 14px 8px
}
}
</style>
